import { useImpersonation } from "@/contexts/ImpersonationContext";
import { hasMinRole } from "@/lib/constants";

export function usePermissions() {
  const { activeUser } = useImpersonation();

  const isAdmin = hasMinRole(activeUser?.role ?? "user", "admin");
  const isSuperadmin = hasMinRole(activeUser?.role ?? "user", "superadmin");

  // Merk: «kan tildele timer» (Timetildeling) styres nå av prosjektrolle-
  // matrisen via edit_budget (useProjectPermissions), ikke en hardkodet
  // admin/PL-sjekk her. Se ProjectDetailLayout.

  return {
    isAdmin,
    isSuperadmin,
    activeUserId: activeUser?.id ?? null,
  };
}
